
 const cutStrings = (value) => {
    if(value === undefined)
        return ' '
    const result = value.split(' ', 5).concat(["..."])
        return result.map((element) => element+' ')
}
export default cutStrings;